import { render, staticRenderFns } from "./main-details.vue?vue&type=template&id=36369103&"
import script from "./main-details.vue?vue&type=script&lang=js&"
export * from "./main-details.vue?vue&type=script&lang=js&"
import style0 from "./main-details.vue?vue&type=style&index=0&id=36369103&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports